import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import * as Styled from './components';

export interface ContactDetailsProps {}

export const ContactDetails: FC<ContactDetailsProps> = (props) => {
  const { translate } = useTranslation();
  return (
    <Styled.ItemContainer>
      <Styled.ItemWrapper>
        <Styled.IconWrapper />
        <Styled.Label>{translate('common.inputs.phone.label')}</Styled.Label>
      </Styled.ItemWrapper>
    </Styled.ItemContainer>
  );
};
